var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHwLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Under_Wallet_Layer",
    "data-name": "Under Wallet Layer",
    viewBox: "21 27 84 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sea_Green_to_Teal",
    "data-name": "Sea Green to Teal",
    x1: 85.21,
    y1: 107.46,
    x2: 35.78,
    y2: 21.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018c72"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20}.cls-2{fill:url(#Sea_Green_to_Teal)}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29 27a8 8 0 00-8 8v57a7 7 0 007 7h70a7 7 0 007-7V46a7 7 0 00-7-7h-5V29a2.07 2.07 0 00-2-2zm0 4h60v8H29a4 4 0 010-8zm72 61a3 3 0 01-3 3H28a3 3 0 01-3-3V41.91A8 8 0 0029 43h69a3 3 0 013 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.63 89.33H56.47a2 2 0 01-2-2V77H44.12a2 2 0 01-2-2V61.93a2 2 0 012-2h10.3V49.57a2 2 0 012-2h13.11a2 2 0 012 2v10.36h10.35a2 2 0 012 2V75a2 2 0 01-2 2H71.63v10.33a2 2 0 01-2 2zm-11.16-4h9.16V75a2 2 0 012-2h10.25v-9.07H69.53a2 2 0 01-2-2V51.57h-9.11v10.36a2 2 0 01-2 2h-10.3V73h10.35a2 2 0 012 2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29 27a8 8 0 00-8 8v57a7 7 0 007 7h70a7 7 0 007-7V46a7 7 0 00-7-7h-5V29a2.07 2.07 0 00-2-2zm0 4h60v8H29a4 4 0 010-8zm72 61a3 3 0 01-3 3H28a3 3 0 01-3-3V41.91A8 8 0 0029 43h69a3 3 0 013 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.63 89.33H56.47a2 2 0 01-2-2V77H44.12a2 2 0 01-2-2V61.93a2 2 0 012-2h10.3V49.57a2 2 0 012-2h13.11a2 2 0 012 2v10.36h10.35a2 2 0 012 2V75a2 2 0 01-2 2H71.63v10.33a2 2 0 01-2 2zm-11.16-4h9.16V75a2 2 0 012-2h10.25v-9.07H69.53a2 2 0 01-2-2V51.57h-9.11v10.36a2 2 0 01-2 2h-10.3V73h10.35a2 2 0 012 2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwLogoColor);
export default __webpack_public_path__ + "static/media/hw_logo_color.1b1d459909f94b98e5014e47da432e4f.svg";
export { ForwardRef as ReactComponent };